"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFormToUniversalLoanSource = exports.mapFormToProduct = exports.FormName = void 0;
const Product_1 = require("./Product");
const loan_1 = require("./loan");
/**
 * The entire list of our front-end forms.
 */
var FormName;
(function (FormName) {
    FormName["AGRICULTURAL"] = "agricultural";
    FormName["AG_LINE_OF_CREDIT"] = "agLineOfCredit";
    FormName["AG_PURCHASE_EQUIPMENT"] = "agPurchaseEquipment";
    FormName["AG_REFINANCE_PROPERTY"] = "agRefinanceProperty";
    FormName["AG_PURCHASE_ACREAGE"] = "agPurchaseAcreage";
    FormName["AUTOLOAN"] = "autoloan";
    FormName["AUTOPREQUAL"] = "autoprequal";
    FormName["CLOSING_COSTS"] = "closingCosts";
    FormName["COMMERCIAL"] = "commercial";
    FormName["COMMERCIALBRIDGELOAN"] = "commercialBridgeLoan";
    FormName["COMMERCIALEQUIPMENT"] = "commercialEquipment";
    FormName["COMMERCIALPURCHASE"] = "commercialPurchase";
    FormName["COMMERCIALREFINANCE"] = "commercialRefinance";
    FormName["COMMERCIALRENEW"] = "commercialRenew";
    FormName["COMMERCIALVEHICLE"] = "commercialVehicle";
    FormName["CONTACT"] = "contact";
    FormName["CONSTRUCTION"] = "construction";
    FormName["CREDITBOOSTER"] = "creditBooster";
    FormName["CREDITCARD"] = "creditCard";
    FormName["FINANCIALSTATEMENT"] = "financialStatement";
    FormName["HOMEEQUITY"] = "homeEquity";
    FormName["HOME_EQUITY_RATES"] = "homeEquityRates";
    FormName["HOME_EQUITY_TURBO"] = "homeEquityExpress";
    FormName["HOMEEQUITYLONGFORM"] = "homeEquityLongForm";
    FormName["INSURANCE_QUOTE"] = "insuranceQuote";
    FormName["LAND"] = "land";
    FormName["LONGFORM"] = "longForm";
    FormName["OTHER_VEHICLE"] = "otherVehicle";
    FormName["OVERDRAFTPROTECTION"] = "overdraftProtection";
    FormName["PERSONALLOAN"] = "personalLoan";
    FormName["PURCHASE_TURBO"] = "purchaseTurbo";
    FormName["REFINANCE_TURBO"] = "refinanceTurbo";
    FormName["REVERSE"] = "reverse";
    FormName["SBLINEOFCREDIT"] = "sbLineOfCredit";
    FormName["SBTERM"] = "sbTerm";
    FormName["SHORT_FORM_PURCHASE"] = "shortFormPurchase";
    FormName["SHORT_FORM_REFINANCE"] = "shortFormRefinance";
})(FormName = exports.FormName || (exports.FormName = {}));
/**
 * This maps from form name to product.  Returns undefined if the form does not map
 * to an existing product.
 *
 * @param {FormName} formName
 * @returns {Product | unknown}
 */
const mapFormToProduct = (formName) => {
    switch (formName) {
        case FormName.AGRICULTURAL:
            return Product_1.Product.AGRICULTURAL;
        case FormName.AG_LINE_OF_CREDIT:
            return Product_1.Product.AGRICULTURAL;
        case FormName.AG_PURCHASE_EQUIPMENT:
            return Product_1.Product.AGRICULTURAL;
        case FormName.AG_REFINANCE_PROPERTY:
            return Product_1.Product.AGRICULTURAL;
        case FormName.AG_PURCHASE_ACREAGE:
            return Product_1.Product.AGRICULTURAL;
        case FormName.AUTOLOAN:
            return Product_1.Product.AUTO_LOAN;
        case FormName.AUTOPREQUAL:
            return Product_1.Product.AUTO_PREQUAL;
        case FormName.CLOSING_COSTS:
            return Product_1.Product.CLOSING_COSTS;
        case FormName.COMMERCIAL:
            return Product_1.Product.COMMERCIAL;
        case FormName.COMMERCIALBRIDGELOAN:
            return Product_1.Product.COMMERCIAL;
        case FormName.COMMERCIALEQUIPMENT:
            return Product_1.Product.COMMERCIAL;
        case FormName.COMMERCIALPURCHASE:
            return Product_1.Product.COMMERCIAL;
        case FormName.COMMERCIALREFINANCE:
            return Product_1.Product.COMMERCIAL;
        case FormName.COMMERCIALRENEW:
            return Product_1.Product.COMMERCIAL;
        case FormName.COMMERCIALVEHICLE:
            return Product_1.Product.COMMERCIAL;
        case FormName.CONTACT:
            return undefined;
        case FormName.CONSTRUCTION:
            return Product_1.Product.CONSTRUCTION;
        case FormName.CREDITBOOSTER:
            return Product_1.Product.CREDIT_BOOSTER;
        case FormName.CREDITCARD:
            return Product_1.Product.CREDIT_CARD;
        case FormName.FINANCIALSTATEMENT:
            return Product_1.Product.FINANCIAL_STATEMENT;
        case FormName.HOMEEQUITY:
            return Product_1.Product.HOME_EQUITY;
        case FormName.HOME_EQUITY_RATES:
            return Product_1.Product.HOME_EQUITY;
        case FormName.HOME_EQUITY_TURBO:
            return Product_1.Product.HOME_EQUITY_TURBO;
        case FormName.HOMEEQUITYLONGFORM:
            return Product_1.Product.HOME_EQUITY;
        case FormName.INSURANCE_QUOTE:
            return Product_1.Product.INSURANCE_QUOTE;
        case FormName.LAND:
            return Product_1.Product.LAND;
        case FormName.LONGFORM:
            return Product_1.Product.DIGITAL_MORTGAGE;
        case FormName.OTHER_VEHICLE:
            return Product_1.Product.OTHER_VEHICLE;
        case FormName.OVERDRAFTPROTECTION:
            return Product_1.Product.OVERDRAFT_PROTECTION;
        case FormName.PERSONALLOAN:
            return Product_1.Product.PERSONAL_LOAN;
        case FormName.PURCHASE_TURBO:
            return Product_1.Product.PURCHASE_TURBO;
        case FormName.REFINANCE_TURBO:
            return Product_1.Product.REFINANCE_TURBO;
        case FormName.REVERSE:
            return Product_1.Product.REVERSE_MORTGAGE;
        case FormName.SBLINEOFCREDIT:
            return Product_1.Product.SMALL_BUSINESS;
        case FormName.SBTERM:
            return Product_1.Product.SMALL_BUSINESS;
        case FormName.SHORT_FORM_PURCHASE:
            return Product_1.Product.DIGITAL_MORTGAGE;
        case FormName.SHORT_FORM_REFINANCE:
            return Product_1.Product.DIGITAL_MORTGAGE;
        default:
            return undefined;
    }
};
exports.mapFormToProduct = mapFormToProduct;
/**
 * This maps from form name to product.  Returns undefined if the form does not map
 * to an existing product.
 *
 * @param {FormName} formName
 * @returns {UniversalLoanSource | undefined}
 */
const mapFormToUniversalLoanSource = (formName) => {
    switch (formName) {
        case FormName.AUTOLOAN:
            return loan_1.UniversalLoanSource.AUTO;
        case FormName.COMMERCIALBRIDGELOAN:
            return loan_1.UniversalLoanSource.COMMERCIAL_BRIDGE_LOAN;
        case FormName.COMMERCIALEQUIPMENT:
            return loan_1.UniversalLoanSource.COMMERCIAL_EQUIPMENT;
        case FormName.COMMERCIALPURCHASE:
            return loan_1.UniversalLoanSource.COMMERCIAL_PURCHASE;
        case FormName.COMMERCIALREFINANCE:
            return loan_1.UniversalLoanSource.COMMERCIAL_REFINANCE;
        case FormName.COMMERCIALVEHICLE:
            return loan_1.UniversalLoanSource.COMMERCIAL_VEHICLE;
        case FormName.CREDITBOOSTER:
            return loan_1.UniversalLoanSource.BOOSTER;
        case FormName.CREDITCARD:
            return loan_1.UniversalLoanSource.CREDIT;
        case FormName.OTHER_VEHICLE:
            return loan_1.UniversalLoanSource.OTHER;
        case FormName.OVERDRAFTPROTECTION:
            return loan_1.UniversalLoanSource.OVERDRAFT_PROTECTION;
        case FormName.PERSONALLOAN:
            return loan_1.UniversalLoanSource.PERSONAL;
        case FormName.REVERSE:
            return loan_1.UniversalLoanSource.REVERSE;
        case FormName.SBLINEOFCREDIT:
            return loan_1.UniversalLoanSource.SB_LINE_OF_CREDIT;
        case FormName.SBTERM:
            return loan_1.UniversalLoanSource.SB_TERM;
        default:
            return undefined;
    }
};
exports.mapFormToUniversalLoanSource = mapFormToUniversalLoanSource;
